export const ROUTE_HOOKS_KEY = "@@route-hooks";
const getHooks = (component) => component?.[ROUTE_HOOKS_KEY];

export const provideHooks = (hooks) => (component) => {
  component[ROUTE_HOOKS_KEY] = hooks;

  return component;
};

export const trigger = (hookName, component, ...args) =>
  Promise.resolve().then(() => getHooks(component)?.[hookName]?.(...args));
